<div [class]="{'panel-overlay-parent': showPanelOverlay}">
  <div class="panel-overlay">
    <div><strong>Portfolio Labels cannot be edited when more than 1,000 portfolios are selected.<br/>Please reduce the number of selected portfolios to edit this setting.</strong></div>
  </div>
  <div class="block">Assign custom labels to your portfolios for organizing, filtering and rebalancing.</div>
  <div class="hblock bold">{{customCategory}}</div>
  <div class="block">
    <a (click)="showAddLabelsDialog()">+ Add label(s)</a><span style="margin-left: 10px;"><a (click)="showRemoveLabelsDialog()">&ndash; Remove label(s)</a></span>
  </div>
  @if (currentLabels.length > 0) {
    <div class="block">
      <div class="label container">
        @for (item of currentLabels; track item) {
          <span>
            <div class="label button">{{item.name}}</div>
          </span>
        }
      </div>
    </div>
  }
  @if (addedLabels.length > 0) {
    <div class="block">
      <div class="label container">
        <div class="label text">Adding:</div>
        @for (item of addedLabels; track item) {
          <span>
            <div class="label button">+ {{item.name}}</div>
          </span>
        }
      </div>
    </div>
  }
  @if (removedLabels.length > 0) {
    <div>
      <div class="label container">
        <div class="label text">Removing:</div>
        @for (item of removedLabels; track item) {
          <span>
            <div class="label button">&ndash; {{item.name}}</div>
          </span>
        }
      </div>
    </div>
  }
</div>
